import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_96blrd2y: FaireBrandEntity = {
  token: "b_96blrd2y",
  type: "brand",
  name: "Tender Loving Empire",
  avatarUrl:
    "https://cdn.faire.com/fastly/5c869a0bdc7e2067b17229d88d45d91b1ed66ee03cfa1130888cdcadb99533d7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1daabd167115ed66786887dac9171a5f61d0d608f1f17bb125794756b7a81c44.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5c869a0bdc7e2067b17229d88d45d91b1ed66ee03cfa1130888cdcadb99533d7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1daabd167115ed66786887dac9171a5f61d0d608f1f17bb125794756b7a81c44.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 51,
  isTopShop: true,
  isInsider: true,
  description:
    "Tender Loving Empire curates a collection of handmade goods and music from hundreds of independent makers and musicians for people who want to support their creative community, surround themselves with beauty and live wholehearted.\n\nFounded in 2007 in a tiny out of the way shop in NW Portland,  Tender Loving Empire now operates 7 stores in the Pacific Northwest, selling the art and music of over 500 different artists.\n\nYour choice to support Tender Loving Empire is a choice to support hundreds of small businesses. Together we can make our communities more vibrant, creative, compassionate and connected.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:05.931Z",
    importedBy: "entity-db-cli",
  },
};
